<template>
  <transload-and-return-to-base :back="{ name: 'IncidentProcessTransload' }"/>
</template>

<script>
import TransloadAndReturnToBase from "@/components/3pl/IncidentAndRequest/Transload/TransloadAndReturnToBase";
export default {
  components: { 
    TransloadAndReturnToBase,
  },
};
</script>

<style>
</style>